import React, { createContext, useContext, useState } from "react";
import GlobalMissingDialog from "./GlobalMissingDialog";
import GlobalReminderDialog from "./GlobalReminderDialog";

// Context to manage dialog state
const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
    const [dialogState, setDialogState] = useState({
        type: null,
        data: null,
    });

    // Show dialog with specific type and content
    const showDialog = (type, data = {}) => {
        setDialogState({ type, data });
    };

    // Hide dialog
    const hideDialog = () => {
        setDialogState({ type: null, data: null });
    };

    return (
        <DialogContext.Provider
            value={{
                dialogType: dialogState.type,
                dialogData: dialogState.data,
                showDialog,
                hideDialog,
            }}
        >
            {children}
            <GlobalMissingDialog />
            <GlobalReminderDialog />
        </DialogContext.Provider>
    );
};

export const useDialog = () => useContext(DialogContext);
